import { Action } from '@ngrx/store';
import { Enrollment, HttpError } from '@rd/types';

export enum EnrollmentActionTypes {
  LOAD_ENROLLMENTS = '[Programs] Load Enrollments',
  LOAD_ENROLLMENTS_SUCCESS = '[Programs] Load Enrollments Success',
  LOAD_ENROLLMENTS_FAIL = '[Programs] Load Enrollments Fail',
}

export class LoadEnrollments implements Action {
  readonly type = EnrollmentActionTypes.LOAD_ENROLLMENTS;
}

export class LoadEnrollmentsSuccess implements Action {
  readonly type = EnrollmentActionTypes.LOAD_ENROLLMENTS_SUCCESS;

  constructor(public payload: Enrollment[]) {}
}

export class LoadEnrollmentsFail implements Action {
  readonly type = EnrollmentActionTypes.LOAD_ENROLLMENTS_FAIL;

  constructor(public payload: HttpError) {}
}

export type EnrollmentActions =
  | LoadEnrollments
  | LoadEnrollmentsSuccess
  | LoadEnrollmentsFail;
